<div
  #container
  class="container hero relative"
  [ngClass]="(stickyEnabled$ | async) ? 'ps-medium-y' : 'pr-small-y'"
  [class.search-form]="stickyEnabled$ | async"
  [class.search-bar-open]="searchBarOptionListVisible$ | async"
  [@scrollAnimation]="state$ | async"
  data-elastic-exclude
  data-testid="search-form-container"
>
  @if (backdropElement && (stickyEnabled$ | async)) {
    <div class="container-backdrop"></div>
  }
  <ng-container *ngIf="showFilters">
    <div
      class="search-bar-container grid-col-12 grid-max-width"
      [ngClass]="{
        'has-filter-chips': (selectedDestinations$ | async)?.length > 0,
      }"
    >
      <fin-destination-search-bar
        *ngIf="(allDestinations$ | async) && (selectedDestinations$ | async)"
        class="col-1-12 to-field md-col-1-6 search-bar"
        [allDestinations$]="allDestinations$"
        [selectedDestinations]="selectedDestinations$ | async"
        [closeOptionsList$]="closeSearchBarOptionsList$"
        (valueChange)="onFilterToValueChange($event)"
        (inputFocusState)="onInputFilter($event)"
        (optionsListVisibilityChanged)="onOptionsListVisibilityChanged($event)"
      ></fin-destination-search-bar>
      @if (isClient) {
        <fin-destination-search-filters
          [meta]="meta"
          [sticky$]="stickyEnabled$"
          [searchBarVisible$]="(state$ | async) === ANIMATION_STATE.VISIBLE | finToObservable"
          (mobileFiltersOpened)="onMobileFiltersOpened($event)"
          [clearFilters$]="clearFilters$"
          class="search-filters"
        ></fin-destination-search-filters>
      }
      <fin-destination-search-filter-chips
        *ngIf="(selectedDestinations$ | async)?.length"
        [selectedDestinations]="selectedDestinations$ | async"
        (tagRemove)="onFilterToValueChange($event)"
        class="col-1-12 filter-chips"
      ></fin-destination-search-filter-chips>
    </div>
  </ng-container>
</div>
